import { Map, Set } from "immutable";
import { ofType } from "redux-observable";
import {
  map as mapFunction,
  mergeMap,
  debounceTime,
  withLatestFrom
} from "rxjs/operators";
import { from } from "rxjs";
import createReducer from "../util/createReducer";
import { addDataContainer } from "../data/ducks";

export const CLEAR_STATE = "vgde/filters/clear-state";
export const CHANGE_VALUE = "vgde/filters/change-value";
export const LOAD_CONTAINER = "vgde/map/load-container";
export const INDICATORS_LOADED = "vgde/filters/indicators-loaded";

export const STORE_INDICATORS = "vgde/filters/STORE_INDICATORS";

const initialState = Map({
  typing: "",
  disease: "",
  layer: "",
  year: 0,
  type: "INDICATOR",
  containers: Set(),
  indicatorsLoaded: false,
  indicators: {}
});

export default createReducer(initialState, {
  [CHANGE_VALUE]: (state, { payload: { key, value } }) => state.set(key, value),
  [LOAD_CONTAINER]: (state, { payload: { id } }) =>
    state.set("containers", state.get("containers").add(id)),
  [INDICATORS_LOADED]: state => state.set("indicatorsLoaded", true),
  [STORE_INDICATORS]: (state, { payload: { data } }) => {
    const dataMap = data.reduce(
      (acc, current) => ({ ...acc, [current.id]: current }),
      {}
    );
    return state.set("indicators", dataMap);
  },
  [CLEAR_STATE]: () => initialState
});

export function clearState() {
  return {
    type: CLEAR_STATE
  };
}

export function changeValue(key, value) {
  return {
    type: CHANGE_VALUE,
    payload: {
      key,
      value
    }
  };
}

export function loadContainer(id) {
  return {
    type: LOAD_CONTAINER,
    payload: {
      id
    }
  };
}

export function indicatorsLoaded() {
  return {
    type: INDICATORS_LOADED
  };
}

export function storeIndicators(data) {
  return {
    type: STORE_INDICATORS,
    payload: {
      data
    }
  };
}

export const queryEpic = (action$, store$) =>
  action$.pipe(
    ofType(CHANGE_VALUE, LOAD_CONTAINER),
    debounceTime(1000),
    withLatestFrom(store$),
    mergeMap(([, store]) => {
      const filters = store.filters.toJS();
      const { containers } = filters;
      return from(containers).pipe(
        mergeMap(containerId => {
          const promise = Promise.resolve({ data: [] });
          return from(promise).pipe(
            mapFunction(response => response.data),
            mapFunction(data => {
              return addDataContainer(containerId, data);
            })
          );
        })
      );
    })
  );



// WEBPACK FOOTER //
// ./src/components/filters/ducks.js